import React from 'react';
import { FaTrophy, FaUserTie } from 'react-icons/fa';

const MembershipTrophy = ({ status }) => {
  const getMembershipTrophy = (status) => {
    switch (status) {
      case 'Gold':
        return <FaTrophy className="gold-trophy" />;
      case 'Silver':
        return <FaTrophy className="silver-trophy" />;
      case 'Bronze':
        return <FaTrophy className="bronze-trophy" />;
      case 'Staff':
        return <FaUserTie className="staff-icon" style={{ color: 'grey' }} />;
      default:
        return null;
    }
  };

  return getMembershipTrophy(status);
};

export default MembershipTrophy;
